<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="VN L2/L3コネクト設定"
  >
    <template v-slot:header="{ cancel }">
      <div>
        <v-card-title class="screen-title">VN L2/L3コネクト設定</v-card-title>
      </div>

      <div class="d-flex flex-row align-start ga-2">
        <v-btn v-if="active !== 3" color="primary" @click="downLoad"
          >設定ダウンロード</v-btn
        >
        <!-- 最初のページのみ設定アップロードが必要 -->
        <template v-if="active === 1">
          <v-btn color="primary" @click="upLoad">設定アップロード</v-btn>
        </template>
        <button
          type="button"
          aria-label="Close"
          class="close ml-5"
          @click="cancel"
        >
          ×
        </button>
      </div>
    </template>

    <template v-if="isLoaded" v-slot:body="{ cancel }">
      <app-stepper
        :size="3"
        :titles="['基本設定', 'NW設定', '設定確認']"
        v-model="active"
      >
        <!-- Stepper1:基本設定 -->
        <template v-slot:[`content(1)`]="{ next }">
          <validation-observer
            ref="observer"
            v-slot="{ handleSubmit }"
            as="div"
          >
            <v-form novalidate @submit.stop.prevent="handleSubmit(next)">
              <v-card-text class="pa-0">
                <div class="modal-body">
                  <v-container>
                    <div class="stepper-content">
                      <!-- VNコネクト番号 -->
                      <v-row v-if="isEdit">
                        <v-col>
                          <app-label-group
                            label="VNコネクト番号"
                            :value="wnumber"
                          />
                        </v-col>
                      </v-row>
                      <!-- VNコネクト名 -->
                      <v-row>
                        <v-col>
                          <app-badge
                            item="VNコネクト名"
                            :msg="
                              $filter.message('info_max_length', {
                                maxLength: '20',
                              })
                            "
                          />
                          <validation-provider
                            name="vnConnectName"
                            v-model="form.vnConnectName"
                            label="VNコネクト名"
                            :rules="{
                              required: true,
                              max: { length: 20 },
                              alpha_num_zenkaku: true,
                            }"
                            v-slot="{ componentField, errorMessage, meta }"
                          >
                            <app-form-input
                              v-bind="componentField"
                              :field-meta="meta"
                              :error-messages="errorMessage"
                            />
                          </validation-provider>
                        </v-col>
                      </v-row>
                      <!-- 回線番号 -->
                      <v-row>
                        <v-col v-if="isEdit">
                          <app-label-group
                            label="回線番号"
                            :value="form.enumber"
                          />
                        </v-col>
                        <v-col v-else>
                          <app-badge item="回線番号" :isInfo="false" />
                          <validation-provider
                            name="enumber"
                            v-model="form.enumber"
                            label="回線番号"
                            :rules="{
                              required: true,
                            }"
                            v-slot="{ componentField, errorMessage, meta }"
                          >
                            <app-select-search
                              :items="lineNumberList"
                              v-bind="componentField"
                              :error-messages="errorMessage"
                              :field-meta="meta"
                            />
                          </validation-provider>
                        </v-col>
                      </v-row>
                      <!-- L2VN -->
                      <v-row>
                        <v-col v-if="isEdit"
                          ><app-label-group
                            label="L2VN"
                            :value="`${form.l2VnName}:${form.l2VnCode}(${
                              form.l2VnVlanIdType === 'SPECIFIED'
                                ? form.l2VnVlanId
                                : form.l2VnVlanIdType === 'OTHER'
                                  ? 'Other'
                                  : 'Untag'
                            })`"
                          />
                        </v-col>
                        <v-col v-else>
                          <app-badge item="L2VN" :isInfo="false" />
                          <validation-provider
                            name="l2VnSelect"
                            v-model="l2VnSelect"
                            label="L2VN"
                            :rules="{
                              required: true,
                            }"
                            v-slot="{ componentField, errorMessage }"
                          >
                            <app-multi-select
                              :options="l2VnListOptions"
                              :custom-label="l2VnCustomLabel"
                              track-by="vpnVnCode"
                              group-label="label"
                              group-values="l2VnList"
                              v-bind="componentField"
                              :error-messages="errorMessage"
                            >
                              <template #option="{ option }">
                                <template v-if="option.$isLabel">
                                  <div class="multiselect-thead">
                                    <p class="v-col-4">
                                      {{ option.$groupLabel.vnName }}
                                    </p>
                                    <p class="v-col-4">
                                      {{ option.$groupLabel.vpnVnCode }}
                                    </p>
                                    <p class="v-col-3">
                                      {{ option.$groupLabel.vlanIdType }}
                                    </p>
                                  </div>
                                </template>
                                <div class="multiselect-tbody" v-else>
                                  <p class="v-col-4">{{ option.vnName }}</p>
                                  <p class="v-col-4">{{ option.vpnVnCode }}</p>
                                  <p
                                    class="v-col-3"
                                    v-if="option.vlanIdType === 'SPECIFIED'"
                                  >
                                    {{ option.vlanId }}
                                  </p>
                                  <p class="v-col-3" v-else>
                                    {{
                                      $filter.enumTo(
                                        option.vlanIdType,
                                        "vlanIdType"
                                      )
                                    }}
                                  </p>
                                </div>
                              </template>
                            </app-multi-select>
                          </validation-provider>
                        </v-col>
                      </v-row>

                      <!-- L2/L3コネクト VLAN -->
                      <v-row>
                        <v-col v-if="isEdit">
                          <app-label-group
                            label="L2/L3コネクト VLAN"
                            :value="
                              form.vnl2l3VlanIdType === 'SPECIFIED'
                                ? form.vnl2l3VnVlanId
                                : form.vnl2l3VlanIdType === 'OTHER'
                                  ? 'Other'
                                  : 'Untag'
                            "
                        /></v-col>
                        <v-col v-else>
                          <app-badge
                            item="L2/L3コネクト VLAN"
                            :isRequired="false"
                            :isInfo="
                              l2VnSelect !== null &&
                              l2VnSelect.vlanIdType === 'OTHER'
                            "
                            :msg="
                              $filter.message('info_half_width_num', {
                                max: 4094,
                              })
                            "
                          />
                          <template
                            v-if="
                              l2VnSelect === null ||
                              l2VnSelect.vlanIdType === 'OTHER'
                            "
                          >
                            <validation-provider
                              name="vnl2l3VnVlanId"
                              v-model.number="form.vnl2l3VnVlanId"
                              label="L2/L3コネクト VLAN"
                              :rules="{
                                numeric: true,
                                between: { min: 1, max: 4094 },
                              }"
                              v-slot="{ componentField, errorMessage, meta }"
                            >
                              <app-form-input-number
                                v-bind="componentField"
                                :field-meta="
                                  l2VnSelect?.vlanIdType === 'OTHER'
                                    ? meta
                                    : null
                                "
                                :error-messages="
                                  l2VnSelect?.vlanIdType === 'OTHER'
                                    ? errorMessage
                                    : null
                                "
                                :disabled="l2VnSelect === null"
                              />
                            </validation-provider>
                          </template>
                          <template
                            v-else-if="l2VnSelect.vlanIdType === 'SPECIFIED'"
                          >
                            <div class="ml-3">{{ form.vnl2l3VnVlanId }}</div>
                          </template>
                          <template
                            v-else-if="l2VnSelect.vlanIdType === 'UNTAG'"
                          >
                            <div class="ml-3">-</div>
                          </template>
                        </v-col>
                      </v-row>
                      <!-- L3VPN/VN -->
                      <v-row>
                        <v-col v-if="isEdit"
                          ><app-label-group
                            label="L3VPN/VN"
                            :value="
                              form.l3VpnVnCode.charAt(0) === `B`
                                ? form.l3VpnVnCode
                                : form.l3VpnVnName + ':' + form.l3VpnVnCode
                            "
                          />
                        </v-col>
                        <v-col v-else>
                          <app-badge item="L3VPN/VN" :isInfo="false" />
                          <validation-provider
                            name="l3VnSelect"
                            v-model="l3VnSelect"
                            label="L3VPN/VN"
                            :rules="{
                              required: true,
                            }"
                            v-slot="{ componentField, errorMessage }"
                          >
                            <app-multi-select
                              :options="l3VnListOptions"
                              :custom-label="l3VnCustomLabel"
                              track-by="vpnVnCode"
                              group-label="label"
                              group-values="l3VnList"
                              v-bind="componentField"
                              :error-messages="errorMessage"
                            >
                              <template #option="{ option }">
                                <template v-if="option.$isLabel">
                                  <div class="multiselect-thead" no-gutters>
                                    <p class="v-col-5">
                                      {{ option.$groupLabel.vnName }}
                                    </p>
                                    <p class="v-col-5">
                                      {{ option.$groupLabel.vpnVnCode }}
                                    </p>
                                  </div>
                                </template>
                                <div class="multiselect-tbody" v-else>
                                  <p class="v-col-5">
                                    {{ $filter.emptyTo(option.vnName, "-") }}
                                  </p>
                                  <p class="v-col-5">{{ option.vpnVnCode }}</p>
                                </div>
                              </template>
                            </app-multi-select>
                          </validation-provider>
                        </v-col>
                      </v-row>
                      <!-- ルーティング種別 -->
                      <v-row>
                        <v-col
                          ><app-badge item="ルーティング種別" :isInfo="false" />
                          <validation-provider
                            name="routingType"
                            v-model="form.routingType"
                            label="ルーティング種別"
                            :rules="{ required: true }"
                            v-slot="{ componentField, errorMessage, meta }"
                          >
                            <app-select
                              v-bind="componentField"
                              :field-meta="meta"
                              :error-messages="errorMessage"
                              :items="routingTypeOptions"
                              item-title="text"
                              item-value="value"
                            >
                              <template #prepend-item>
                                <div class="ml-3 text-caption">
                                  選択してください
                                </div>
                              </template>
                            </app-select>
                          </validation-provider>
                        </v-col>
                      </v-row>
                    </div>
                  </v-container>
                </div>
                <v-alert
                  v-if="!!uploadAlert"
                  class="my-4"
                  :text="uploadAlert"
                />
              </v-card-text>

              <v-divider></v-divider>
              <!-- FOOTER -->
              <v-card-actions>
                <v-list-item class="w-100 pa-1">
                  <template v-slot:prepend>
                    <v-btn @click="cancel" variant="outlined" color="primary"
                      >戻る</v-btn
                    >
                  </template>
                  <template v-slot:append>
                    <v-btn type="submit" color="primary" variant="flat"
                      >次へ</v-btn
                    >
                  </template>
                </v-list-item>
              </v-card-actions>
            </v-form>
          </validation-observer>
        </template>

        <!-- stepper2:NW設定 -->
        <template v-slot:[`content(2)`]="{ next, prev }">
          <!-- ルーティング種別がStaticの場合 -->
          <validation-observer
            v-slot="{ handleSubmit }"
            v-if="form.routingType === 'STATIC'"
            :initial-values="{
              static: form.static,
            }"
            as="div"
          >
            <v-form novalidate @submit.stop.prevent="handleSubmit(next)">
              <v-card-text class="pa-0">
                <div class="modal-body">
                  <v-container
                    ><div class="stepper-content" ref="stepper2">
                      <!-- WANアドレス -->
                      <v-row>
                        <v-col v-if="isEdit"
                          ><app-label-group
                            label="WANアドレス"
                            :value="form.wanAddress"
                          />
                        </v-col>
                        <v-col v-else
                          ><app-badge
                            item="WANアドレス"
                            :msg="
                              '・' +
                              $filter.message('info_cidr_ip_v4_with_subnet_2', {
                                subnet: '30',
                              }) +
                              '\n' +
                              '・' +
                              $filter.message('info_cidr_subnet', {
                                subnet: '16-/30',
                              })
                            "
                          />
                          <validation-provider
                            name="wanAddress"
                            v-model="form.wanAddress"
                            label="WANアドレス"
                            :rules="{
                              required: true,
                              is_ip_subnet: {
                                min: 16,
                                max: 30,
                              },
                              is_not_loopback_ip: true,
                              is_not_multicast_ip: true,
                              is_not_class_e_ip: true,
                              is_not_broadcast_ip: true,
                              is_not_network_ip: true,
                            }"
                            v-slot="{ componentField, errorMessage, meta }"
                          >
                            <app-form-input
                              v-bind="componentField"
                              :field-meta="meta"
                              :error-messages="errorMessage"
                              :placeholder="
                                $filter.message(
                                  'placeholder_ip_address_with_subnet30'
                                )
                              "
                            />
                          </validation-provider>
                        </v-col>
                      </v-row>
                      <!-- 経路 -->
                      <app-label-group label="経路" class="mb-3" />
                      <v-row class="ml-1">
                        <!-- LANアドレスタイトル -->
                        <v-col class="address-title">
                          <app-badge
                            item="LANアドレス"
                            :isRequired="form.static.length > 0"
                            :msg="$filter.message('info_lan_address')"
                          />
                        </v-col>
                        <!-- ネクストホップアドレスタイトル -->
                        <v-col class="address-title mr-9">
                          <app-badge
                            item="ネクストホップアドレス"
                            :isRequired="form.static.length > 0"
                            :msg="
                              $filter.message('info_ip_address_v4_2', {
                                host: '2',
                              })
                            "
                          />
                        </v-col>
                      </v-row>
                      <validation-array
                        name="static"
                        v-slot="{ fields, push, remove }"
                        ref="staticAddress"
                      >
                        <template
                          v-for="(item, index) in fields"
                          :key="item.key"
                        >
                          <v-row class="ga-2">
                            <!-- LANアドレスフォーム -->
                            <v-col class="py-0">
                              <validation-provider
                                :name="`lanAddress${item.key}`"
                                v-model="form.static[index].lanAddress"
                                label="LANアドレス"
                                :rules="{
                                  required:
                                    form.static.length !== 0 ||
                                    !!form.static![index].nextHopAddress,
                                  is_ip_subnet: {
                                    min: 1,
                                    max: 32,
                                    exclude: [31],
                                  },
                                  is_not_same_wan: { wan: form.wanAddress },
                                  is_not_loopback_ip: true,
                                  is_not_multicast_ip: true,
                                  is_not_class_e_ip: true,
                                  is_not_broadcast_ip: true,
                                  is_network_address: true,
                                  duplicate: { list: lanAddressList(index) },
                                }"
                                v-slot="{ componentField, errorMessage, meta }"
                                :keepValue="true"
                              >
                                <app-form-input
                                  v-bind="componentField"
                                  :field-meta="meta"
                                  :error-messages="errorMessage"
                                  :placeholder="
                                    $filter.message(
                                      'placeholder_ip_address_with_subnet24_or_subnet32'
                                    )
                                  "
                                />
                              </validation-provider>
                            </v-col>
                            <!-- ネクストホップアドレスフォーム -->
                            <v-col class="py-0">
                              <validation-provider
                                :name="`nextHopAddress${item.key}`"
                                v-model="form.static[index].nextHopAddress"
                                label="ネクストホップアドレス"
                                :rules="{
                                  // 2個以上は必須、特定の回線種別は必須, 片方が入力されている場合は必須
                                  required:
                                    form.static.length !== 0 ||
                                    !!form.static![index].lanAddress,
                                  is_ipv4: true,
                                  cross_wan_address_within_range: {
                                    wan: form.wanAddress,
                                  },
                                  is_not_loopback_ip: true,
                                  is_not_multicast_ip: true,
                                  is_not_class_e_ip: true,
                                  is_not_broadcast_ip: {
                                    range: form.wanAddress,
                                  },
                                  is_not_network_ip: {
                                    range: form.wanAddress,
                                  },
                                }"
                                v-slot="{ componentField, errorMessage, meta }"
                                :keepValue="true"
                              >
                                <app-form-input
                                  v-bind="componentField"
                                  :field-meta="meta"
                                  :error-messages="errorMessage"
                                  :placeholder="
                                    $filter.message(
                                      'placeholder_ip_address_3',
                                      { host: '2' }
                                    )
                                  "
                                />
                              </validation-provider>
                            </v-col>

                            <v-btn
                              icon="$mdiMinus"
                              size="small"
                              variant="outlined"
                              class="rounded-sm"
                              @click="removeLAN(index, remove)"
                            />
                          </v-row>
                        </template>
                        <v-row justify="end">
                          <v-btn
                            icon="$mdiPlus"
                            size="small"
                            variant="outlined"
                            class="rounded-sm"
                            @click="addLAN(push)"
                          />
                        </v-row>
                      </validation-array>
                      <!-- 備考 -->
                      <v-row>
                        <v-col>
                          <app-badge
                            item="備考"
                            :msg="
                              $filter.message('info_max_length', {
                                maxLength: '20',
                              })
                            "
                            :isRequired="false"
                          />
                          <validation-provider
                            name="description"
                            v-model="form.description"
                            label="備考"
                            :rules="{
                              max: { length: 20 },
                            }"
                            v-slot="{ componentField, errorMessage, meta }"
                          >
                            <app-form-input
                              v-bind="componentField"
                              :field-meta="meta"
                              :error-messages="errorMessage"
                            />
                          </validation-provider>
                        </v-col>
                      </v-row>
                    </div>
                  </v-container>
                </div>
              </v-card-text>

              <v-divider></v-divider>
              <!-- FOOTER -->
              <v-card-actions>
                <v-list-item class="w-100 pa-1">
                  <template v-slot:prepend>
                    <v-btn @click="prev" variant="outlined" color="primary"
                      >戻る</v-btn
                    >
                  </template>
                  <template v-slot:append>
                    <v-btn type="submit" color="primary" variant="flat"
                      >次へ</v-btn
                    >
                  </template>
                </v-list-item>
              </v-card-actions>
            </v-form>
          </validation-observer>

          <!-- ルーティング種別がBGP4の場合 -->
          <cross-validation-observer
            v-slot="{ handleSubmit }"
            v-if="form.routingType === 'BGP4'"
            as="div"
          >
            <v-form novalidate @submit.stop.prevent="handleSubmit(next)">
              <v-card-text class="pa-0">
                <div class="modal-body">
                  <v-container
                    ><div class="stepper-content">
                      <!-- WANアドレス -->
                      <v-row>
                        <v-col v-if="isEdit"
                          ><app-label-group
                            label="WANアドレス"
                            :value="form.wanAddress"
                          />
                        </v-col>
                        <v-col v-else
                          ><app-badge
                            item="WANアドレス"
                            :msg="
                              '・' +
                              $filter.message('info_cidr_ip_v4_with_subnet_2', {
                                subnet: '30',
                              }) +
                              '\n' +
                              '・' +
                              $filter.message('info_cidr_subnet', {
                                subnet: '16-/30',
                              })
                            "
                          />
                          <validation-provider
                            name="wanAddress"
                            v-model="form.wanAddress"
                            label="WANアドレス"
                            :rules="{
                              required: true,
                              is_ip_subnet: {
                                min: 16,
                                max: 30,
                              },
                              is_not_loopback_ip: true,
                              is_not_multicast_ip: true,
                              is_not_class_e_ip: true,
                              is_not_broadcast_ip: true,
                              is_not_network_ip: true,
                            }"
                            v-slot="{ componentField, errorMessage, meta }"
                          >
                            <app-form-input
                              v-bind="componentField"
                              :field-meta="meta"
                              :error-messages="errorMessage"
                              :placeholder="
                                $filter.message(
                                  'placeholder_ip_address_with_subnet30'
                                )
                              "
                            />
                          </validation-provider>
                        </v-col>
                      </v-row>
                      <!-- Peer1 -->
                      <v-row>
                        <v-col>
                          <h3>Peer1</h3>
                          <v-radio-group
                            v-model="peer1Setting"
                            inline
                            hide-details
                          >
                            <v-radio
                              v-for="option in peerSettingOptions"
                              :key="option.text"
                              :label="option.text"
                              :value="option.value"
                            />
                          </v-radio-group>
                        </v-col>
                      </v-row>
                      <div v-if="peer1Setting">
                        <!-- AS番号 -->
                        <v-row>
                          <v-col>
                            <app-badge
                              item="AS番号"
                              :msg="
                                $filter.message(`info_as_number`, {
                                  numberArray:
                                    '1～9995、9997～64949、64970～65501、65504～65535',
                                })
                              "
                            />
                            <validation-provider
                              name="asNumberPeer1"
                              v-model.number="form.bgp4![0].asNumber"
                              label="AS番号(Peer1)"
                              :rules="{
                                required: true,
                                numeric: true,
                                is_number_range: {
                                  range:
                                    '1-9995,9997-64949,64970-65501,65504-65535',
                                },
                              }"
                              v-slot="{ componentField, errorMessage, meta }"
                            >
                              <app-form-input-number
                                v-bind="componentField"
                                :field-meta="meta"
                                :error-messages="errorMessage"
                              />
                            </validation-provider>
                          </v-col>
                        </v-row>
                        <!-- ピアIPアドレス -->
                        <v-row>
                          <v-col>
                            <app-badge
                              item="ピアIPアドレス"
                              :msg="
                                $filter.message(`info_ip_address_v4_2`, {
                                  host: '2',
                                })
                              "
                            />
                            <validation-provider
                              name="peerIpAddressPeer1"
                              v-model="form.bgp4![0].peerIpAddress"
                              label="ピアIPアドレス(Peer1)"
                              :rules="{
                                required: true,
                                is_ipv4: true,
                                cross_wan_address_within_range: {
                                  wan: form.wanAddress,
                                },
                                is_not_loopback_ip: true,
                                is_not_multicast_ip: true,
                                is_not_class_e_ip: true,
                                is_not_broadcast_ip: {
                                  range: form.wanAddress,
                                },
                                is_not_network_ip: {
                                  range: form.wanAddress,
                                },
                                is_not_eq: peer2Setting
                                  ? {
                                      target: '@peerIpAddressPeer2',
                                      targetField: 'ピアIPアドレス(Peer2)',
                                    }
                                  : undefined,
                              }"
                              v-slot="{ componentField, errorMessage, meta }"
                            >
                              <app-form-input
                                v-bind="componentField"
                                :field-meta="meta"
                                :error-messages="errorMessage"
                                :placeholder="
                                  $filter.message('placeholder_ip_address_3', {
                                    host: '2',
                                  })
                                "
                              />
                            </validation-provider>
                          </v-col>
                        </v-row>
                        <!-- MD5キー -->
                        <v-row>
                          <v-col>
                            <app-badge
                              item="MD5キー"
                              :isRequired="false"
                              :msg="$filter.message(`info_md5`)"
                            />
                            <validation-provider
                              name="md5KeyPeer1"
                              v-model="form.bgp4![0].md5Key"
                              label="MD5キー(Peer1)"
                              :rules="{
                                is_md5: true,
                              }"
                              v-slot="{ componentField, errorMessage, meta }"
                            >
                              <app-form-input
                                v-bind="componentField"
                                :field-meta="meta"
                                :error-messages="errorMessage"
                              />
                            </validation-provider>
                          </v-col>
                        </v-row>
                        <!-- Maximum Prefix -->
                        <v-row>
                          <v-col>
                            <app-badge item="Maximum Prefix" :isInfo="false" />
                            <validation-provider
                              name="maximumPrefixPeer1"
                              v-model="form.bgp4![0].maximumPrefix"
                              label="Maximum Prefix(Peer1)"
                              :rules="
                                peer2Setting
                                  ? {
                                      confirmed: {
                                        target: '@maximumPrefixPeer2',
                                        targetField: 'Maximum Prefix(Peer2)',
                                      },
                                      required: true,
                                    }
                                  : { required: true }
                              "
                              v-slot="{ componentField, errorMessage, meta }"
                            >
                              <app-select
                                :items="maxPrefixOptions"
                                item-title="text"
                                item-value="value"
                                v-bind="componentField"
                                :field-meta="meta"
                                :error-messages="errorMessage"
                              />
                            </validation-provider>
                          </v-col>
                        </v-row>
                        <!-- Local Preference -->
                        <v-row>
                          <v-col>
                            <app-badge
                              item="Local Preference"
                              :isInfo="false"
                            />
                            <app-select
                              :items="localOptions"
                              item-title="text"
                              item-value="value"
                              v-model="form.bgp4![0].localPreference"
                            />
                          </v-col>
                        </v-row>
                        <!-- MED -->
                        <v-row>
                          <v-col>
                            <app-badge item="MED" :isInfo="false" />
                            <app-select
                              :items="medOptions"
                              item-title="text"
                              item-value="value"
                              v-model="form.bgp4![0].med"
                            />
                          </v-col>
                        </v-row>
                        <!-- 経路集約 -->
                        <v-row>
                          <v-col>
                            <app-badge item="経路集約" :isInfo="false" />
                            <app-select
                              :items="routeOptions"
                              item-title="text"
                              item-value="value"
                              v-model="form.bgp4![0].isRouteAggregation"
                            />
                          </v-col>
                        </v-row>
                      </div>
                      <!-- Peer2 -->
                      <v-row>
                        <v-col>
                          <h3>Peer2</h3>
                          <v-radio-group
                            v-model="peer2Setting"
                            inline
                            hide-details
                          >
                            <v-radio
                              v-for="option in peerSettingOptions"
                              :key="option.text"
                              :label="option.text"
                              :value="option.value"
                            />
                          </v-radio-group>
                        </v-col>
                      </v-row>
                      <div v-if="peer2Setting">
                        <!-- AS番号 -->
                        <v-row>
                          <v-col>
                            <app-badge
                              item="AS番号"
                              :msg="
                                $filter.message(`info_as_number`, {
                                  numberArray:
                                    '1～9995、9997～64949、64970～65501、65504～65535',
                                })
                              "
                            />
                            <validation-provider
                              name="asNumberPeer2"
                              v-model.number="form.bgp4![1].asNumber"
                              label="AS番号(Peer2)"
                              :rules="{
                                required: true,
                                numeric: true,
                                is_number_range: {
                                  range:
                                    '1-9995,9997-64949,64970-65501,65504-65535',
                                },
                              }"
                              v-slot="{ componentField, errorMessage, meta }"
                            >
                              <app-form-input-number
                                v-bind="componentField"
                                :field-meta="meta"
                                :error-messages="errorMessage"
                              />
                            </validation-provider>
                          </v-col>
                        </v-row>
                        <!-- ピアIPアドレス -->
                        <v-row>
                          <v-col>
                            <app-badge
                              item="ピアIPアドレス"
                              :msg="
                                $filter.message(`info_ip_address_v4_2`, {
                                  host: '3',
                                })
                              "
                            />
                            <validation-provider
                              name="peerIpAddressPeer2"
                              v-model="form.bgp4![1].peerIpAddress"
                              label="ピアIPアドレス(Peer2)"
                              :rules="{
                                required: true,
                                is_ipv4: true,
                                cross_wan_address_within_range: {
                                  wan: form.wanAddress,
                                },
                                is_not_loopback_ip: true,
                                is_not_multicast_ip: true,
                                is_not_class_e_ip: true,
                                is_not_broadcast_ip: {
                                  range: form.wanAddress,
                                },
                                is_not_network_ip: {
                                  range: form.wanAddress,
                                },
                                is_not_eq: peer2Setting
                                  ? {
                                      target: '@peerIpAddressPeer1',
                                      targetField: 'ピアIPアドレス(Peer1)',
                                    }
                                  : undefined,
                              }"
                              v-slot="{ componentField, errorMessage, meta }"
                            >
                              <app-form-input
                                v-bind="componentField"
                                :field-meta="meta"
                                :error-messages="errorMessage"
                                :placeholder="
                                  $filter.message('placeholder_ip_address_3', {
                                    host: '3',
                                  })
                                "
                              />
                            </validation-provider>
                          </v-col>
                        </v-row>
                        <!-- MD5キー -->
                        <v-row>
                          <v-col>
                            <app-badge
                              item="MD5キー"
                              :isRequired="false"
                              :msg="$filter.message(`info_md5`)"
                            />
                            <validation-provider
                              name="md5KeyPeer2"
                              v-model="form.bgp4![1].md5Key"
                              label="MD5キー(Peer2)"
                              :rules="{
                                is_md5: true,
                              }"
                              v-slot="{ componentField, errorMessage, meta }"
                            >
                              <app-form-input
                                v-bind="componentField"
                                :field-meta="meta"
                                :error-messages="errorMessage"
                              />
                            </validation-provider>
                          </v-col>
                        </v-row>
                        <!-- Maximum Prefix -->
                        <v-row>
                          <v-col>
                            <app-badge item="Maximum Prefix" :isInfo="false" />
                            <validation-provider
                              name="maximumPrefixPeer2"
                              v-model="form.bgp4![1].maximumPrefix"
                              label="Maximum Prefix(Peer2)"
                              :rules="
                                peer1Setting
                                  ? {
                                      confirmed: {
                                        target: '@maximumPrefixPeer1',
                                        targetField: 'Maximum Prefix(Peer1)',
                                      },
                                      required: true,
                                    }
                                  : { required: true }
                              "
                              v-slot="{ componentField, errorMessage, meta }"
                            >
                              <app-select
                                :items="maxPrefixOptions"
                                item-title="text"
                                item-value="value"
                                v-bind="componentField"
                                :field-meta="meta"
                                :error-messages="errorMessage"
                              />
                            </validation-provider>
                          </v-col>
                        </v-row>
                        <!-- Local Preference -->
                        <v-row>
                          <v-col>
                            <app-badge
                              item="Local Preference"
                              :isInfo="false"
                            />
                            <app-select
                              :items="localOptions"
                              item-title="text"
                              item-value="value"
                              v-model="form.bgp4![1].localPreference"
                            />
                          </v-col>
                        </v-row>
                        <!-- MED -->
                        <v-row>
                          <v-col>
                            <app-badge item="MED" :isInfo="false" />
                            <app-select
                              :items="medOptions"
                              item-title="text"
                              item-value="value"
                              v-model="form.bgp4![1].med"
                            />
                          </v-col>
                        </v-row>
                        <!-- 経路集約 -->
                        <v-row>
                          <v-col>
                            <app-badge item="経路集約" :isInfo="false" />
                            <app-select
                              :items="routeOptions"
                              item-title="text"
                              item-value="value"
                              v-model="form.bgp4![1].isRouteAggregation"
                            />
                          </v-col>
                        </v-row>
                      </div>
                      <!-- 関連項目チェック：BGP4選択時に「Peer1」「Peer2」どちらかが有効になっていること -->
                      <cross-validation-provider
                        :passed="validSomePeer"
                        vid="SomePeer"
                        class="my-2"
                      >
                        {{ $filter.message("required_some_peer") }}
                      </cross-validation-provider>
                      <!-- 備考 -->
                      <v-row>
                        <v-col>
                          <app-badge
                            item="備考"
                            :msg="
                              $filter.message('info_max_length', {
                                maxLength: '20',
                              })
                            "
                            :isRequired="false"
                          />
                          <validation-provider
                            name="description"
                            v-model="form.description"
                            label="備考"
                            :rules="{
                              max: { length: 20 },
                            }"
                            v-slot="{ componentField, errorMessage, meta }"
                          >
                            <app-form-input
                              v-bind="componentField"
                              :field-meta="meta"
                              :error-messages="errorMessage"
                            />
                          </validation-provider>
                        </v-col>
                      </v-row>
                    </div>
                  </v-container>
                </div>
              </v-card-text>

              <v-divider></v-divider>
              <!-- FOOTER -->
              <v-card-actions>
                <v-list-item class="w-100 pa-1">
                  <template v-slot:prepend>
                    <v-btn @click="prev" variant="outlined" color="primary"
                      >戻る</v-btn
                    >
                  </template>
                  <template v-slot:append>
                    <v-btn type="submit" color="primary" variant="flat"
                      >次へ</v-btn
                    >
                  </template>
                </v-list-item>
              </v-card-actions>
            </v-form>
          </cross-validation-observer>

          <!-- ルーティング種別がOSPFの場合 -->
          <validation-observer
            v-slot="{ handleSubmit }"
            v-if="form.routingType === 'OSPF'"
            as="div"
          >
            <v-form novalidate @submit.stop.prevent="handleSubmit(next)">
              <v-card-text class="pa-0">
                <div class="modal-body">
                  <v-container
                    ><div class="stepper-content">
                      <!-- WANアドレス -->
                      <v-row>
                        <v-col v-if="isEdit"
                          ><app-label-group
                            label="WANアドレス"
                            :value="form.wanAddress"
                          />
                        </v-col>
                        <v-col v-else
                          ><app-badge
                            item="WANアドレス"
                            :msg="
                              '・' +
                              $filter.message('info_cidr_ip_v4_with_subnet_2', {
                                subnet: '30',
                              }) +
                              '\n' +
                              '・' +
                              $filter.message('info_cidr_subnet', {
                                subnet: '16-/30',
                              })
                            "
                          />
                          <validation-provider
                            name="wanAddress"
                            v-model="form.wanAddress"
                            label="WANアドレス"
                            :rules="{
                              required: true,
                              is_ip_subnet: {
                                min: 16,
                                max: 30,
                              },
                              is_not_loopback_ip: true,
                              is_not_multicast_ip: true,
                              is_not_class_e_ip: true,
                              is_not_broadcast_ip: true,
                              is_not_network_ip: true,
                            }"
                            v-slot="{ componentField, errorMessage, meta }"
                          >
                            <app-form-input
                              v-bind="componentField"
                              :field-meta="meta"
                              :error-messages="errorMessage"
                              :placeholder="
                                $filter.message(
                                  'placeholder_ip_address_with_subnet30'
                                )
                              "
                            />
                          </validation-provider>
                        </v-col>
                      </v-row>
                      <!-- エリア番号 -->
                      <v-row>
                        <v-col>
                          <app-badge
                            item="エリア番号"
                            :msg="$filter.message('info_num_max', { max: 255 })"
                          />
                          <validation-provider
                            name="areaNumber"
                            v-model.number="form.ospf!.areaNumber"
                            label="エリア番号"
                            :rules="{
                              required: true,
                              numeric: true,
                              between: {
                                min: 0,
                                max: 255,
                              },
                            }"
                            v-slot="{ componentField, errorMessage, meta }"
                          >
                            <app-form-input-number
                              v-bind="componentField"
                              :field-meta="meta"
                              :error-messages="errorMessage"
                            />
                          </validation-provider>
                        </v-col>
                      </v-row>
                      <!-- 備考 -->
                      <v-row>
                        <v-col>
                          <app-badge
                            item="備考"
                            :msg="
                              $filter.message('info_max_length', {
                                maxLength: '20',
                              })
                            "
                            :isRequired="false"
                          />
                          <validation-provider
                            name="description"
                            v-model="form.description"
                            label="備考"
                            :rules="{
                              max: { length: 20 },
                            }"
                            v-slot="{ componentField, errorMessage, meta }"
                          >
                            <app-form-input
                              v-bind="componentField"
                              :field-meta="meta"
                              :error-messages="errorMessage"
                            />
                          </validation-provider>
                        </v-col>
                      </v-row>
                    </div>
                  </v-container>
                </div>
              </v-card-text>

              <v-divider></v-divider>
              <!-- FOOTER -->
              <v-card-actions>
                <v-list-item class="w-100 pa-1">
                  <template v-slot:prepend>
                    <v-btn @click="prev" variant="outlined" color="primary"
                      >戻る</v-btn
                    >
                  </template>
                  <template v-slot:append>
                    <v-btn type="submit" color="primary" variant="flat"
                      >次へ</v-btn
                    >
                  </template>
                </v-list-item>
              </v-card-actions>
            </v-form>
          </validation-observer>
        </template>

        <!-- stepper3:設定確認 -->
        <template v-slot:[`content(3)`]="{ prev }">
          <v-card-text class="pa-0">
            <div class="modal-body">
              <v-container
                ><div class="stepper-content">
                  <!-- 確認文言 -->
                  <v-row>
                    <strong v-if="isEdit">
                      こちらの内容でVN
                      L2/L3コネクト設定を変更します。よろしいですか？
                    </strong>
                    <strong v-else>
                      こちらの内容でVN
                      L2/L3コネクトを設定します。よろしいですか？
                    </strong>
                  </v-row>
                  <!-- VNコネクト名 -->
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="VNコネクト名"
                        :value="form.vnConnectName"
                      />
                    </v-col>
                  </v-row>
                  <!-- 回線番号 -->
                  <v-row>
                    <v-col>
                      <app-label-group label="回線番号" :value="form.enumber" />
                    </v-col>
                  </v-row>
                  <!-- L2VN -->
                  <v-row>
                    <v-col>
                      <app-label-group label="L2VN">
                        <template #value>
                          <div v-if="isEdit" class="ml-3">
                            <span>
                              {{ form.l2VnName }}:{{ form.l2VnCode }}({{
                                form.l2VnVlanIdType === "SPECIFIED"
                                  ? form.l2VnVlanId
                                  : form.l2VnVlanIdType === "OTHER"
                                    ? "Other"
                                    : "Untag"
                              }})
                            </span>
                          </div>
                          <!-- 追加且つL2VN選択済の場合 -->
                          <div v-else-if="l2VnSelect" class="ml-3">
                            <span
                              >{{ l2VnSelect.vnName }}:{{
                                l2VnSelect.vpnVnCode
                              }}({{
                                l2VnSelect.vlanIdType === "SPECIFIED"
                                  ? l2VnSelect.vlanId
                                  : l2VnSelect.vlanIdType === "UNTAG"
                                    ? "Untag"
                                    : "Other"
                              }})
                            </span>
                          </div>
                        </template>
                      </app-label-group>
                    </v-col>
                  </v-row>
                  <!-- L2/L3コネクト VLAN -->
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="L2/L3コネクト VLAN"
                        :value="$filter.emptyTo(form.vnl2l3VnVlanId, '-')"
                      />
                    </v-col>
                  </v-row>
                  <!-- L3VPN/VN -->
                  <v-row>
                    <v-col>
                      <app-label-group label="L3VPN/VN">
                        <template #value>
                          <div v-if="isEdit" class="ml-3">
                            <span v-if="form.l3VpnVnCode.charAt(0) === `B`">{{
                              form.l3VpnVnCode
                            }}</span>
                            <span v-else>{{
                              form.l3VpnVnName + ":" + form.l3VpnVnCode
                            }}</span>
                          </div>
                          <!-- 追加且つL3選択済の場合 -->
                          <div v-else-if="l3VnSelect" class="ml-3">
                            <span v-if="l3VnSelect.vnName">
                              {{
                                l3VnSelect.vnName + ":" + l3VnSelect.vpnVnCode
                              }}</span
                            >
                            <span v-else>
                              {{ l3VnSelect.vpnVnCode }}
                            </span>
                          </div>
                        </template>
                      </app-label-group>
                    </v-col>
                  </v-row>
                  <!-- ルーティング種別 -->
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="ルーティング種別"
                        :value="$filter.enumTo(form.routingType, 'routingType')"
                      />
                    </v-col>
                  </v-row>
                  <!-- WANアドレス -->
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="WANアドレス"
                        :value="form.wanAddress"
                      />
                    </v-col>
                  </v-row>
                  <!-- ルーティング種別がStaticの場合 -->
                  <template v-if="form.routingType === 'STATIC'">
                    <!-- 経路 -->
                    <v-row>
                      <app-label-group label="経路" class="ml-1 mt-2" />
                    </v-row>
                    <v-row class="ml-1">
                      <v-col cols="4">
                        <app-label-group>
                          <template #label
                            ><span class="text-caption"
                              >LANアドレス</span
                            ></template
                          >
                          <template #value>
                            <div v-if="form.static && form.static.length > 0">
                              <div
                                class="ml-3"
                                v-for="(e, index) in form.static"
                                :key="index"
                              >
                                {{ $filter.emptyTo(e.lanAddress, "-") }}
                              </div>
                            </div>
                            <div v-else class="ml-3">-</div>
                          </template>
                        </app-label-group>
                      </v-col>
                      <v-col cols="4">
                        <app-label-group>
                          <template #label
                            ><span class="text-caption"
                              >ネクストホップアドレス</span
                            ></template
                          >
                          <template #value>
                            <div v-if="form.static && form.static.length > 0">
                              <div
                                class="ml-3"
                                v-for="(e, index) in form.static"
                                :key="index"
                              >
                                {{ $filter.emptyTo(e.nextHopAddress, "-") }}
                              </div>
                            </div>
                            <div v-else class="ml-3">-</div>
                          </template>
                        </app-label-group>
                      </v-col>
                    </v-row>
                  </template>
                  <!-- ルーティング種別がBGP4の場合 -->
                  <v-row v-else-if="form.routingType === 'BGP4'">
                    <!-- Peer1選択時 -->
                    <v-col cols="6" v-if="peer1Setting">
                      <v-row>
                        <v-col>
                          <h3>Peer1</h3>
                        </v-col>
                      </v-row>
                      <!-- AS番号 -->
                      <v-row>
                        <v-col>
                          <app-label-group
                            label="AS番号"
                            :value="form.bgp4![0].asNumber"
                          />
                        </v-col>
                      </v-row>
                      <!-- ピアIPアドレス -->
                      <v-row>
                        <v-col>
                          <app-label-group
                            label="ピアIPアドレス"
                            :value="form.bgp4![0].peerIpAddress"
                          />
                        </v-col>
                      </v-row>
                      <!-- MD5キー -->
                      <v-row>
                        <v-col>
                          <app-label-group
                            label="MD5キー"
                            :value="$filter.emptyTo(form.bgp4![0].md5Key, '-')"
                          />
                        </v-col>
                      </v-row>
                      <!-- Maximum Prefix -->
                      <v-row>
                        <v-col>
                          <app-label-group
                            label="Maximum Prefix"
                            :value="form.bgp4![0].maximumPrefix"
                          />
                        </v-col>
                      </v-row>
                      <!-- Local Preference -->
                      <v-row>
                        <v-col>
                          <app-label-group
                            label="Local Preference"
                            :value="
                              $filter.enumTo(
                                form.bgp4![0].localPreference,
                                'localPreference'
                              )
                            "
                          />
                        </v-col>
                      </v-row>
                      <!-- MED -->
                      <v-row>
                        <v-col>
                          <app-label-group
                            label="MED"
                            :value="$filter.enumTo(form.bgp4![0].med, 'med')"
                          />
                        </v-col>
                      </v-row>
                      <!-- 経路集約 -->
                      <v-row>
                        <v-col>
                          <app-label-group
                            label="経路集約"
                            :value="
                              $filter.enumTo(
                                form.bgp4![0].isRouteAggregation,
                                'on_off'
                              )
                            "
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                    <!-- Peer2選択時 -->
                    <v-col cols="6" v-if="peer2Setting">
                      <v-row>
                        <v-col>
                          <h3>Peer2</h3>
                        </v-col>
                      </v-row>
                      <!-- AS番号 -->
                      <v-row>
                        <v-col>
                          <app-label-group
                            label="AS番号"
                            :value="form.bgp4![1].asNumber"
                          />
                        </v-col>
                      </v-row>
                      <!-- ピアIPアドレス -->
                      <v-row>
                        <v-col>
                          <app-label-group
                            label="ピアIPアドレス"
                            :value="form.bgp4![1].peerIpAddress"
                          />
                        </v-col>
                      </v-row>
                      <!-- MD5キー -->
                      <v-row>
                        <v-col>
                          <app-label-group
                            label="MD5キー"
                            :value="$filter.emptyTo(form.bgp4![1].md5Key, '-')"
                          />
                        </v-col>
                      </v-row>
                      <!-- Maximum Prefix -->
                      <v-row>
                        <v-col>
                          <app-label-group
                            label="Maximum Prefix"
                            :value="form.bgp4![1].maximumPrefix"
                          />
                        </v-col>
                      </v-row>
                      <!-- Local Preference -->
                      <v-row>
                        <v-col>
                          <app-label-group
                            label="Local Preference"
                            :value="
                              $filter.enumTo(
                                form.bgp4![1].localPreference,
                                'localPreference'
                              )
                            "
                          />
                        </v-col>
                      </v-row>
                      <!-- MED -->
                      <v-row>
                        <v-col>
                          <app-label-group
                            label="MED"
                            :value="$filter.enumTo(form.bgp4![1].med, 'med')"
                          />
                        </v-col>
                      </v-row>
                      <!-- 経路集約 -->
                      <v-row>
                        <v-col>
                          <app-label-group
                            label="経路集約"
                            :value="
                              $filter.enumTo(
                                form.bgp4![1].isRouteAggregation,
                                'on_off'
                              )
                            "
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <!-- ルーティング種別がOSPFの場合 -->
                  <template v-else-if="form.routingType === 'OSPF'">
                    <!-- エリア番号 -->
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="エリア番号"
                          :value="form.ospf?.areaNumber"
                        />
                      </v-col>
                    </v-row>
                  </template>
                  <!-- 備考 -->
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="備考"
                        :value="$filter.emptyTo(form.description, '-')"
                      />
                    </v-col>
                  </v-row>
                </div>
              </v-container>
            </div>
          </v-card-text>

          <v-divider></v-divider>
          <!-- FOOTER -->
          <v-card-actions>
            <v-list-item class="w-100 pa-1">
              <template v-slot:prepend>
                <v-btn @click="prev" variant="outlined" color="primary"
                  >戻る</v-btn
                >
              </template>
              <template v-slot:append>
                <v-btn
                  @click="settingVNL2L3Connect"
                  color="primary"
                  variant="flat"
                  >設定</v-btn
                >
              </template>
            </v-list-item>
          </v-card-actions>
        </template>
      </app-stepper>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import { VueFinalModal } from "vue-final-modal";
import { UploadError } from "@/services/ConfigDownloadService";
import type {
  Bgp4Peer,
  CreateVNL2L3ConnectRequest,
  StaticRouting,
  UpdateVNL2L3ConnectRequest,
  VNL2L3ConnectDetail,
} from "@/apis/VNL2L3ConnectApi";
import type { VpnVnCode } from "@/apis/InformationApi";
import cloneDeep from "lodash/cloneDeep";
import type { UpperLimitEntity } from "@/apis/UpperLimitApi";
import type { NullableProperty } from "@/shims-vue";
import type { ContractInfo } from "@/apis/ContractApi";
import { mapState } from "vuex";
import sortCompare from "@/services/SortService";

/** 追加form用に定義した型 */
type addFormType = CreateVNL2L3ConnectRequest &
  Pick<
    VNL2L3ConnectDetail,
    | "l2VnName"
    | "l3VpnVnName"
    | "l2VnVlanIdType"
    | "l2VnVlanId"
    | "vnl2l3VlanIdType"
  >;

/** 変更form用に定義した型 */
type changeFormType = UpdateVNL2L3ConnectRequest &
  Pick<
    VNL2L3ConnectDetail,
    | "l2VnName"
    | "l2VnCode"
    | "l3VpnVnName"
    | "l3VpnVnCode"
    | "enumber"
    | "l2VnVlanIdType"
    | "l2VnVlanId"
    | "vnl2l3VlanIdType"
    | "vnl2l3VnVlanId"
    | "wanAddress"
  >;

export default defineComponent({
  name: "VNL2L3ConnectEdit",
  props: {
    // 変更の場合用
    wnumber: {
      type: String as PropType<string>,
      required: false,
    },
    // 変更の場合用
    vnL2L3ConnectDetail: {
      type: Object as PropType<VNL2L3ConnectDetail>,
      required: false,
    },
    // 追加の場合用
    vnl2l3ConnectKeyId: {
      type: String as PropType<string>,
      required: false,
    },
  },
  data() {
    // 新規/更新のformデータを作成
    const form:
      | NullableProperty<addFormType, "routingType">
      | NullableProperty<changeFormType, "routingType"> = (() => {
      if (this.vnL2L3ConnectDetail) {
        // 変更
        const detailCopy = cloneDeep(this.vnL2L3ConnectDetail);
        let bgpList: Bgp4Peer[];
        if (detailCopy.bgp4) {
          if (detailCopy.bgp4.length > 1) {
            bgpList = detailCopy.bgp4;
          } else {
            bgpList = [
              ...detailCopy.bgp4,
              {
                peerName: detailCopy.bgp4.some((v) => v.peerName === "PEER1")
                  ? "PEER2"
                  : "PEER1",
                peerIpAddress: null,
                asNumber: null,
                md5Key: null,
                maximumPrefix: 100,
                localPreference: "LOW_PRIORITY",
                med: "LOW_PRIORITY",
                isRouteAggregation: false,
              },
            ];
          }
        } else {
          bgpList = [
            {
              peerName: "PEER1",
              peerIpAddress: null,
              asNumber: null,
              md5Key: null,
              maximumPrefix: 100,
              localPreference: "LOW_PRIORITY",
              med: "LOW_PRIORITY",
              isRouteAggregation: false,
            },
            {
              peerName: "PEER2",
              peerIpAddress: "",
              asNumber: null,
              md5Key: null,
              maximumPrefix: 100,
              localPreference: "LOW_PRIORITY",
              med: "LOW_PRIORITY",
              isRouteAggregation: false,
            },
          ];
        }
        // staticルートが1件以上ある場合、lanAddressでIPアドレス順に昇順ソートする
        let staticList =
          detailCopy.static.length > 0
            ? detailCopy.static
            : [{ lanAddress: "", nextHopAddress: "" }];
        if (staticList.length > 1) {
          staticList = [...staticList].sort((a, b) =>
            sortCompare(a, b, [["lanAddress", "asc"]])
          );
        }
        const editForm: changeFormType = {
          ...detailCopy,
          bgp4: bgpList.sortBy(["peerName", "asc"]),
          static: staticList.length > 0 ? staticList : [],
          ospf: detailCopy.ospf ? detailCopy.ospf : { areaNumber: "" },
        };
        return editForm;
      } else {
        // 追加
        return {
          enumber: null as string | null,
          vnl2l3ConnectKeyId: this.vnl2l3ConnectKeyId,
          static: [] as StaticRouting[],
          bgp4: [
            {
              peerName: "PEER1",
              peerIpAddress: null,
              asNumber: null,
              md5Key: null,
              maximumPrefix: 100,
              localPreference: "LOW_PRIORITY",
              med: "LOW_PRIORITY",
              isRouteAggregation: false,
            },
            {
              peerName: "PEER2",
              peerIpAddress: "",
              asNumber: null,
              md5Key: null,
              maximumPrefix: 100,
              localPreference: "LOW_PRIORITY",
              med: "LOW_PRIORITY",
              isRouteAggregation: false,
            },
          ],
          ospf: { areaNumber: "" },
        } as addFormType;
      }
    })();
    const peer1Setting: boolean = (() => {
      if (this.vnL2L3ConnectDetail) {
        // 変更の場合、実績の設定値より初期値を付与
        if (this.vnL2L3ConnectDetail.bgp4) {
          return this.vnL2L3ConnectDetail.bgp4.some(
            (v) => v.peerName === "PEER1"
          );
        } else {
          return true;
        }
      } else {
        // 追加の場合はtrue
        return true;
      }
    })();

    const peer2Setting: boolean = (() => {
      if (this.vnL2L3ConnectDetail) {
        // 変更の場合、実績の設定値より初期値を付与
        if (this.vnL2L3ConnectDetail.bgp4) {
          return this.vnL2L3ConnectDetail.bgp4.some(
            (v) => v.peerName === "PEER2"
          );
        } else {
          return false;
        }
      } else {
        // 追加の場合はfalse
        return false;
      }
    })();

    return {
      isLoaded: false,
      /** 入力フォーム */
      form,
      /** VPN/VNコード取得APIの検索結果 */
      vpnVnCodeList: [] as VpnVnCode[],
      /** 回線番号の選択肢 */
      lineNumberList: [] as string[],
      /** BGP4のPEER1の有効、無効 */
      peer1Setting,
      /** BGP4のPEER2の有効、無効 */
      peer2Setting,
      /** L2Vn選択した値保存用 */
      l2VnSelect: null as null | VpnVnCode,
      /** L3Vn選択した値保存用 */
      l3VnSelect: null as null | VpnVnCode,
      /** Step No. */
      active: 1,
      /** Maximum Prefix上限値 */
      maximumPrefixLimit: null as UpperLimitEntity | null,
      /** アップロードエラー */
      uploadAlert: null as string | null,
    };
  },
  watch: {
    /** L2VN選択時の動作 */
    l2VnSelect() {
      // 追加のみ走るロジックので、asは問題ない
      if (this.l2VnSelect?.vlanIdType === "SPECIFIED") {
        (this.form as CreateVNL2L3ConnectRequest).vnl2l3VnVlanId =
          this.l2VnSelect.vlanId;
      } else if (this.l2VnSelect?.vlanIdType === "UNTAG") {
        (this.form as CreateVNL2L3ConnectRequest).vnl2l3VnVlanId = null;
      } else if (this.l2VnSelect?.vlanIdType === "OTHER") {
        (this.form as CreateVNL2L3ConnectRequest).vnl2l3VnVlanId = null;
      } else {
        // l2VnSelectが選択されてない場合、クリアする
        (this.form as CreateVNL2L3ConnectRequest).vnl2l3VnVlanId = null;
      }
    },
    /** Maximum Prefixの設定上限値を取得 */
    async "form.enumber"() {
      if ((this.form as CreateVNL2L3ConnectRequest).enumber) {
        // 契約に対象の回線情報が存在しない場合はサービス開始日が未来日のため上限値設定情報は取得できない
        if (
          !this.contractInfo.contractList.find(
            (e: ContractInfo["contractList"][0]) =>
              e.enumber === (this.form as CreateVNL2L3ConnectRequest).enumber
          )
        ) {
          this.maximumPrefixLimit = {
            upperLimitItemName: "BGP4の最大経路数",
            current: null,
            upperLimit: 100,
            unit: "",
          };
          return;
        }

        this.maximumPrefixLimit = (
          await this.$api.upperLimit.getUpperLimitLine({
            upperLimitLineManageUnit: "VNL2L3",
            enumber: (this.form as CreateVNL2L3ConnectRequest).enumber,
          })
        ).vnl2l3Line!.upperLimitList!.find(
          (v: UpperLimitEntity) => v.upperLimitItemName === "BGP4の最大経路数"
        )!;
      }
    },
    /**
     * Step移動時、Alertをクリアする
     */
    active() {
      this.uploadAlert = null;
    },
  },
  computed: {
    ...mapState("user", {
      contractInfo: "contractInfo",
    }),
    /** 変更の場合、true */
    isEdit(): boolean {
      return !!this.vnL2L3ConnectDetail;
    },
    /** ルーティング種別の選択肢 */
    routingTypeOptions(): {
      value: VNL2L3ConnectDetail["routingType"];
      text: string;
    }[] {
      return [
        { value: "STATIC", text: "Static" },
        { value: "BGP4", text: "BGP4" },
        { value: "OSPF", text: "OSPF" },
      ];
    },
    /** Local Preferenceの選択肢 */
    localOptions(): {
      value: "HIGH_PRIORITY" | "LOW_PRIORITY";
      text: string;
    }[] {
      return [
        { value: "LOW_PRIORITY", text: "OFF(100)" },
        { value: "HIGH_PRIORITY", text: "優先(200)" },
      ];
    },
    /** MEDの選択肢 */
    medOptions(): { value: "HIGH_PRIORITY" | "LOW_PRIORITY"; text: string }[] {
      return [
        { value: "HIGH_PRIORITY", text: "非優先(100)" },
        { value: "LOW_PRIORITY", text: "OFF(0)" },
      ];
    },
    /** 経路集約の選択肢 */
    routeOptions(): { value: boolean; text: string }[] {
      return [
        { value: false, text: "OFF" },
        { value: true, text: "ON" },
      ];
    },
    /** Peer有効/無効の選択肢 */
    peerSettingOptions(): { value: boolean; text: string }[] {
      return [
        { value: true, text: "有効" },
        { value: false, text: "無効" },
      ];
    },
    /** MaximumPrefixの選択肢 */
    maxPrefixOptions(): {
      value: number;
      text: number;
    }[] {
      if (this.maximumPrefixLimit) {
        return [
          { value: 100, text: 100 },
          { value: 200, text: 200 },
          { value: 300, text: 300 },
          { value: 400, text: 400 },
          { value: 500, text: 500 },
          { value: 1000, text: 1000 },
          { value: 1500, text: 1500 },
          { value: 2000, text: 2000 },
        ].filter((v) => v.value <= this.maximumPrefixLimit!.upperLimit);
      } else {
        // 回線番号指定前にルーティング種別をBGP4にされた場合
        return [];
      }
    },
    /** 経路のリスト */
    staticLanList(): StaticRouting[] {
      const validList = this.form.static.filter(
        (v) => !!v.lanAddress && !!v.nextHopAddress
      );
      if (validList.length === 0) {
        return [{ lanAddress: "", nextHopAddress: "" }];
      } else {
        return validList;
      }
    },
    /** L2VNの選択肢
     * L2VPNは考慮しなくてもいい */
    l2VnListOptions(): {
      label: {
        vnName: string;
        vpnVnCode: string;
        vlanIdType: string;
      };
      l2VnList: VpnVnCode[];
    }[] {
      return this.vpnVnCodeList.filter((v) => v.vnType === "L2").length !== 0
        ? [
            {
              label: {
                vnName: "VNネットワーク名",
                vpnVnCode: "VNコード",
                vlanIdType: "VLAN",
              },
              l2VnList: this.vpnVnCodeList.filter((v) => v.vnType === "L2"),
            },
          ]
        : [];
    },
    /** L3VPN/VNの選択肢
     * vnType = "L3"はL3VN
     * vnType = nullの場合はL3VPN */
    l3VnListOptions(): {
      label: {
        vnName: string;
        vpnVnCode: string;
      };
      l3VnList: VpnVnCode[];
    }[] {
      return this.vpnVnCodeList.filter((v) => v.vnType === "L3" || !v.vnType)
        .length !== 0
        ? [
            {
              label: {
                vnName: "VPN/VNネットワーク名",
                vpnVnCode: "VPN/VNコード",
              },
              l3VnList: this.vpnVnCodeList.filter(
                (v) => v.vnType === "L3" || !v.vnType
              ),
            },
          ]
        : [];
    },
    /**「ルーティング設定」が「BGP4」の場合、「有効」が1つ以上選択されていること */
    validSomePeer(): boolean {
      return this.$crossValidation.requiredSome(
        this.peer1Setting,
        this.peer2Setting
      );
    },

    /** 複数設定時にLANアドレスが重複していないこと */
    lanAddressList() {
      return (index: number) => {
        return this.form!.static!
          ? this.form!.static!.map((e) => e.lanAddress).filter(
              (_, num) => num !== index
            )
          : [];
      };
    },
    /** 入力フォームから取得したbgp4の値
     * BGP4以外の場合はnull
     * Peer1、Peer2の中に、有効の方を返却
     * */
    bgp4(): Bgp4Peer[] | null {
      if (this.form.routingType === "BGP4") {
        return this.form.bgp4!.filter((v) => {
          if (v.peerName === "PEER1" && this.peer1Setting) {
            return true;
          } else if (v.peerName === "PEER2" && this.peer2Setting) {
            return true;
          }
          return false;
        });
      } else {
        return null;
      }
    },
    /** 追加の場合、 vnl2l3VlanIdTypeの変換(OHTERの場合は、UNTAGやSPECIFIEDへ変換する) */
    vnl2l3VlanIdType(): "UNTAG" | "SPECIFIED" {
      if (this.l2VnSelect!.vlanIdType === "OTHER") {
        if ((this.form as CreateVNL2L3ConnectRequest).vnl2l3VnVlanId) {
          return "SPECIFIED";
        } else {
          return "UNTAG";
        }
      }
      return this.l2VnSelect!.vlanIdType!;
    },
  },
  async mounted() {
    await this.load();
    this.isLoaded = true;
  },
  methods: {
    async load() {
      if (!this.isEdit) {
        /** 回線番号リスト取得 */
        this.lineNumberList = (
          await this.$api.vNL2L3Connect.getVNL2L3lines()
        ).lineList.sortBy("asc");
        /** VpnVnコードリスト取得 */
        this.vpnVnCodeList = await this.$api.information.getVpnVnCodeList();
      } else {
        // 契約に対象の回線情報が存在しない場合はサービス開始日が未来日のため上限値設定情報は取得できない
        if (
          !this.contractInfo.contractList.find(
            (e: ContractInfo["contractList"][0]) =>
              e.enumber === this.vnL2L3ConnectDetail!.enumber
          )
        ) {
          this.maximumPrefixLimit = {
            upperLimitItemName: "BGP4の最大経路数",
            current: null,
            upperLimit: 100,
            unit: "",
          };
        } else {
          /** Maximum Prefixの設定上限値を取得 */
          this.maximumPrefixLimit = (
            await this.$api.upperLimit.getUpperLimitLine({
              upperLimitLineManageUnit: "VNL2L3",
              enumber: this.vnL2L3ConnectDetail!.enumber,
            })
          ).vnl2l3Line!.upperLimitList!.find(
            (v: UpperLimitEntity) => v.upperLimitItemName === "BGP4の最大経路数"
          )!;
        }
      }
    },
    async settingVNL2L3Connect() {
      if (this.isEdit) {
        /** 変更API呼び出し*/
        await this.$api.vNL2L3Connect.updateVNL2L3Connect(this.wnumber!, {
          vnl2l3ConnectKeyId: this.form.vnl2l3ConnectKeyId,
          vnConnectName: this.form.vnConnectName,
          routingType: this.form.routingType!,
          static:
            this.form.routingType === "STATIC"
              ? this.form.static.length === 1 && !this.form.static[0].lanAddress
                ? []
                : this.form.static
              : [],
          ospf:
            this.form.routingType === "OSPF"
              ? // 要件より画面では数字通りの挙動(先頭に「0」がある場合は「0」を除いた値を登録する)ですが、
                // APIではStringと扱うので、v-model.numberとtoStringの組み合わせて実装になった
                { areaNumber: this.form.ospf!.areaNumber.toString() }
              : null,
          bgp4: this.bgp4,
          description: this.form.description,
        });
      } else {
        /** 追加API呼び出し*/
        await this.$api.vNL2L3Connect.createVNL2L3Connect({
          ...this.form,
          l2VnCode: this.l2VnSelect!.vpnVnCode,
          l3VpnVnCode: this.l3VnSelect!.vpnVnCode,
          // フォームが空欄の場合はUntagとして扱う
          vnl2l3VlanIdType: this.vnl2l3VlanIdType,
          vnl2l3VnVlanId:
            this.l2VnSelect!.vlanIdType === "OTHER" &&
            (this.form as CreateVNL2L3ConnectRequest).vnl2l3VnVlanId
              ? (this.form as CreateVNL2L3ConnectRequest).vnl2l3VnVlanId
              : this.l2VnSelect?.vlanId,
          static:
            this.form.routingType === "STATIC"
              ? this.form.static.filter(
                  (v) => !!v.lanAddress && !!v.nextHopAddress
                )
              : [],
          ospf:
            this.form.routingType === "OSPF"
              ? // 要件より画面では数字通りの挙動(先頭に「0」がある場合は「0」を除いた値を登録する)ですが、
                // APIではStringと扱うので、v-model.numberとtoStringの組み合わせて実装になった
                { areaNumber: this.form.ospf!.areaNumber.toString() }
              : null,
          bgp4: this.bgp4,
        } as CreateVNL2L3ConnectRequest);
      }
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
    /** 設定ダウンロード */
    downLoad() {
      if (this.isEdit) {
        this.$service.configDownload.downloadVNL2L3Connect(
          this.$store.state.user.contractSummary.vnumber,
          this.wnumber!,
          "modify",
          this.form,
          this.peer1Setting,
          this.peer2Setting,
          this.vnL2L3ConnectDetail
        );
      } else {
        this.$service.configDownload.downloadVNL2L3Connect(
          this.$store.state.user.contractSummary.vnumber,
          "",
          "add",
          this.form,
          this.peer1Setting,
          this.peer2Setting,
          null,
          this.l2VnSelect,
          this.l3VnSelect
        );
      }
    },
    /** 設定アップロード */
    async upLoad() {
      try {
        const uploadVNL2L3Connect = this.vnL2L3ConnectDetail
          ? await this.$service.configDownload.uploadVNL2L3Connect(
              "modify",
              undefined,
              this.wnumber
            )
          : await this.$service.configDownload.uploadVNL2L3Connect(
              "add",
              this.$store.state.user.contractSummary.vnumber
            );
        this.uploadAlert = null;
        await this.$confirm(
          "VN L2/L3コネクト設定を上書きします。よろしいですか？"
        );

        this.form.vnConnectName = uploadVNL2L3Connect.vnConnectName;
        if (uploadVNL2L3Connect.static) {
          if (Array.isArray(uploadVNL2L3Connect.static)) {
            if (uploadVNL2L3Connect.static.length > 0) {
              this.form.static = uploadVNL2L3Connect.static;
            } else {
              this.form.static = [{ lanAddress: "", nextHopAddress: "" }];
            }
          }
        } else {
          this.form.static = [{ lanAddress: "", nextHopAddress: "" }];
        }
        this.updateFieldArray(this.form.static);

        if (uploadVNL2L3Connect.ospf) {
          this.form.ospf!.areaNumber = uploadVNL2L3Connect.ospf.areaNumber;
        }

        if (uploadVNL2L3Connect.bgp4) {
          if (Array.isArray(uploadVNL2L3Connect.bgp4)) {
            if (uploadVNL2L3Connect.bgp4.length > 0) {
              const peer1 = uploadVNL2L3Connect.bgp4.find(
                (v: Bgp4Peer) => v.peerName === "PEER1"
              );
              if (peer1) {
                this.peer1Setting = true;
                this.form.bgp4![0].peerIpAddress = peer1.peerIpAddress;
                this.form.bgp4![0].asNumber = peer1.asNumber;
                this.form.bgp4![0].md5Key = peer1.md5Key;
                this.form.bgp4![0].maximumPrefix = peer1.maximumPrefix;
                if (
                  peer1.med === "HIGH_PRIORITY" ||
                  peer1.med === "LOW_PRIORITY"
                ) {
                  this.form.bgp4![0].med = peer1.med;
                } else {
                  this.form.bgp4![0].med = "LOW_PRIORITY";
                }
                if (
                  peer1.localPreference === "HIGH_PRIORITY" ||
                  peer1.localPreference === "LOW_PRIORITY"
                ) {
                  this.form.bgp4![0].localPreference = peer1.localPreference;
                } else {
                  this.form.bgp4![0].localPreference = "LOW_PRIORITY";
                }

                if (typeof peer1.isRouteAggregation === "boolean") {
                  this.form.bgp4![0].isRouteAggregation =
                    peer1.isRouteAggregation;
                } else {
                  this.form.bgp4![0].isRouteAggregation = false;
                }
              } else {
                this.peer1Setting = false;
              }

              const peer2 = uploadVNL2L3Connect.bgp4.find(
                (v: Bgp4Peer) => v.peerName === "PEER2"
              );
              if (peer2) {
                this.peer2Setting = true;
                this.form.bgp4![1].peerIpAddress = peer2.peerIpAddress;
                this.form.bgp4![1].asNumber = peer2.asNumber;
                this.form.bgp4![1].md5Key = peer2.md5Key;
                this.form.bgp4![1].maximumPrefix = peer2.maximumPrefix;

                if (
                  peer2.med === "HIGH_PRIORITY" ||
                  peer2.med === "LOW_PRIORITY"
                ) {
                  this.form.bgp4![1].med = peer2.med;
                } else {
                  this.form.bgp4![1].med = "LOW_PRIORITY";
                }
                if (
                  peer2.localPreference === "HIGH_PRIORITY" ||
                  peer2.localPreference === "LOW_PRIORITY"
                ) {
                  this.form.bgp4![1].localPreference = peer2.localPreference;
                } else {
                  this.form.bgp4![1].localPreference = "LOW_PRIORITY";
                }
                if (typeof peer2.isRouteAggregation === "boolean") {
                  this.form.bgp4![1].isRouteAggregation =
                    peer2.isRouteAggregation;
                } else {
                  this.form.bgp4![1].isRouteAggregation = false;
                }
              } else {
                this.peer2Setting = false;
              }
            } else {
              this.peer1Setting = true;
              this.peer2Setting = false;
              this.form.bgp4 = [
                {
                  peerName: "PEER1",
                  peerIpAddress: null,
                  asNumber: null,
                  md5Key: null,
                  maximumPrefix: 100,
                  localPreference: "LOW_PRIORITY",
                  med: "LOW_PRIORITY",
                  isRouteAggregation: false,
                },
                {
                  peerName: "PEER2",
                  peerIpAddress: "",
                  asNumber: null,
                  md5Key: null,
                  maximumPrefix: 100,
                  localPreference: "LOW_PRIORITY",
                  med: "LOW_PRIORITY",
                  isRouteAggregation: false,
                },
              ];
            }
          }
        } else {
          this.peer1Setting = true;
          this.peer2Setting = false;
          this.form.bgp4 = [
            {
              peerName: "PEER1",
              peerIpAddress: null,
              asNumber: null,
              md5Key: null,
              maximumPrefix: 100,
              localPreference: "LOW_PRIORITY",
              med: "LOW_PRIORITY",
              isRouteAggregation: false,
            },
            {
              peerName: "PEER2",
              peerIpAddress: "",
              asNumber: null,
              md5Key: null,
              maximumPrefix: 100,
              localPreference: "LOW_PRIORITY",
              med: "LOW_PRIORITY",
              isRouteAggregation: false,
            },
          ];
        }

        this.form.description = uploadVNL2L3Connect.description;
        const routingType = this.routingTypeOptions.find(
          (v) => v.value === uploadVNL2L3Connect.routingType
        );
        if (routingType) {
          this.form.routingType = routingType.value;
        } else {
          this.form.routingType = null;
        }
        if (!this.isEdit) {
          // 追加の場合のみ実施
          (this.form as CreateVNL2L3ConnectRequest).enumber =
            uploadVNL2L3Connect.enumber;
          (this.form as CreateVNL2L3ConnectRequest).wanAddress =
            uploadVNL2L3Connect.wanAddress;
          const l2 = this.vpnVnCodeList.find(
            (v) =>
              v.vnType === "L2" && v.vpnVnCode === uploadVNL2L3Connect.l2VnCode
          );
          if (l2) {
            this.l2VnSelect = l2;
          } else {
            this.l2VnSelect = null;
          }
          const l3 = this.vpnVnCodeList.find(
            (v) =>
              (v.vnType === "L3" || !v.vnType) &&
              v.vpnVnCode === uploadVNL2L3Connect.l3VpnVnCode
          );
          if (l3) {
            this.l3VnSelect = l3;
          } else {
            this.l3VnSelect = null;
          }

          this.$nextTick(() => {
            // Other以外は入力項目ではないので、スキップ
            if (this.l2VnSelect?.vlanIdType === "OTHER") {
              // L2VNの変更が発生した場合はwatchでvnl2l3VnVlanId項目の初期化が走るため次のタイミングで値を設定
              (this.form as CreateVNL2L3ConnectRequest).vnl2l3VnVlanId =
                uploadVNL2L3Connect.vnl2l3VnVlanId;
            }
          });
        }
      } catch (e) {
        this.uploadAlert = (e as UploadError).message;
      }
    },
    /**「LANアドレス」と「ネクストホップアドレス」の追加,
     *  ルーティング種別で「STATIC」のみ
     */
    addLAN(push: (item: any) => void) {
      const addItem = { lanAddress: "", nextHopAddress: "" };
      if (this.form.routingType === "STATIC")
        this.form.static = [...this.form.static, addItem];
      push(addItem);
    },
    /**「LANアドレス」と「ネクストホップアドレス」の削除,
     *  ルーティング種別で「STATIC」のみ
     */
    removeLAN(index: number, remove: (idx: number) => void) {
      if (this.form.routingType === "STATIC") {
        this.form.static.splice(index, 1);
        remove(index);
      }
    },
    /**L2VNプルダウンの複数条件を表示*/
    l2VnCustomLabel({ vnName, vpnVnCode, vlanId, vlanIdType }: never) {
      if (this.l2VnSelect?.vlanIdType !== "SPECIFIED")
        return `${vnName}:${vpnVnCode}(${
          vlanIdType === "UNTAG"
            ? "Untag"
            : vlanIdType === "OTHER"
              ? "Other"
              : vlanId
        })`;
      else return `${vnName}:${vpnVnCode}(${vlanId})`;
    },
    /**L3VPN/VNプルダウンの複数条件を表示*/
    l3VnCustomLabel({ vnName, vpnVnCode }: never) {
      if (this.l3VnSelect?.vpnVnCode.charAt(0) === "B") return `${vpnVnCode}`;
      else return `${vnName}:${vpnVnCode}`;
    },
    updateFieldArray(items: unknown[]) {
      // ステッパー2「NW設定」の経路がレンダリングされていない場合、updateFieldArrayメソッドの呼び出しが不要のため、レンダリング可否の判断を行う
      if (this.$refs.staticAddress) {
        (
          this.$refs.staticAddress as {
            replace: (items: unknown[]) => void;
          }
        ).replace([...items]);
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.address-title :deep(.badge-label) {
  font-size: 0.75rem !important;
}
</style>
